const alertMessage = "Formulaire de demande de contact pour des projets d'installation d'infrastructures de recharge pour véhicules électriques, en partenariat avec la Banque des Territoires / Caisse des Dépôts et Consignations, uniquement dans le cas de copropriétés ayant un parking de <strong>plus de 50 places en interieur.</strong>";

export default alertMessage;
